module.exports = __webpack_public_path__ + "ffa542b8444d4ea6a8091adb6f6c746c.svg";